import React, { Fragment } from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Users, Target, Zap, Shield } from 'lucide-react';
import { MrAvatar } from '../components/MrAvatar';
export function MeetMr() {
  return <FeaturePageLayout customContent={<div className="flex justify-center -mt-8 mb-16 relative z-10" data-id="element-1821" data-mp="2l9pqfky4fq4j">
          <MrAvatar size={240} expression="happy" data-id="element-1822" data-mp="2lbssx4ggnbq5" />
        </div>} hero={{
    badge: 'Step 1 of 7',
    h1: <>
            Meet{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-1823" data-mp="1smc2udgbc6x3">
              MR
            </span>
          </>,
    subtitle: 'Your journey begins with a dedicated consultation. We introduce you to MISTR (MR), your AI Chief of Operations, and understand the high-level vision for your business automation.'
  }} problem={{
    subtitle: 'The Initial Challenge',
    cards: [{
      icon: <Users className="w-6 h-6 text-teal" data-id="element-1824" data-mp="2vxvgtccatkc" />,
      title: 'Fragmented Vision',
      desc: 'Businesses often know they need AI but lack a cohesive strategy to implement it effectively.'
    }, {
      icon: <Target className="w-6 h-6 text-purple" data-id="element-1825" data-mp="bwm7xjm34lv4" />,
      title: 'Misaligned Goals',
      desc: 'Without a clear starting point, automation efforts can become disconnected from actual business objectives.'
    }, {
      icon: <Zap className="w-6 h-6 text-blue-400" data-id="element-1826" data-mp="3kbmphjnp8c4l" />,
      title: 'Overwhelming Options',
      desc: 'The AI landscape is vast. Knowing where to start and what tools to use is a massive hurdle.'
    }]
  }} solution={{
    badge: 'The Solution',
    title: 'A Strategic Introduction',
    desc: 'Meeting MR is about aligning your business goals with our AI capabilities. We map out the high-level vision before diving into the details.',
    features: [{
      icon: <Users className="w-6 h-6 text-teal" data-id="element-1827" data-mp="8pn1so87p9cq" />,
      title: 'Vision Alignment',
      desc: 'We sit down to understand your core business objectives and how AI can accelerate them.'
    }, {
      icon: <Shield className="w-6 h-6 text-purple" data-id="element-1828" data-mp="hlchcgmzb9i7" />,
      title: 'Ecosystem Overview',
      desc: 'Get a clear picture of how MR will integrate into and manage your daily operations.'
    }]
  }} data-id="element-1820" data-mp="2q7hm8q1vzwe0" />;
}